import { render } from "./DefaultGDQShortMailTexts.vue?vue&type=template&id=8ec2770c"
import script from "./DefaultGDQShortMailTexts.vue?vue&type=script&lang=js"
export * from "./DefaultGDQShortMailTexts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__